import { render, staticRenderFns } from "./KenyaPayroll.vue?vue&type=template&id=6b08d899&scoped=true&"
import script from "./KenyaPayroll.vue?vue&type=script&lang=js&"
export * from "./KenyaPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b08d899",
  null
  
)

export default component.exports